import { useEffect } from "react";
import queryString from "query-string";
import apiRequest from "utils/ApiRequest/apiRequest";
import Icon from "components/Elements/Icon/Icon";
import { useContent } from "../../../contexts/contentContext/contentContext";
//@ts-ignore
import config from "config";

import styles from "./styles.module.scss";

const AuthenticateAdminLogin = () => {
  const { t } = queryString.parse(window.location.search);
  const { getLanguage } = useContent();

  const handleAuth = async () => {
    const encodedToken = encodeURIComponent(t as string);
    const res = await apiRequest(
      "Users",
      "AuthenticateAdminLogin?token=" + encodedToken
    );

    if (res.status === "error") {
      window.location.href = `${config.baseurl}/${getLanguage() || "en"}/home`;
    } else {
      document.cookie =
        //@ts-ignore
        config.api.jumbomailApiAuthCookie +
        "=" +
        res.data?.BearerToken +
        ";path=/";

      window.location.href = `${config.baseurl}/${getLanguage() || "en"}/home`;
    }
  };

  useEffect(() => {
    if (t) {
      handleAuth();
    }
  }, [t]);

  return (
    <div className={styles.container}>
      <Icon name="mobile-icon-jumbomail" iconClass={styles.jmIcon} />
    </div>
  );
};

export default AuthenticateAdminLogin;
